import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './ProductShiftTracking.css';

const leftVariants = {
  hidden: { opacity: 0, x: -80 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};
const rightVariants = {
  hidden: { opacity: 0, x: 80 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};

const ProductShiftTracking = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' });
  return (
    <section className="shift-tracking-section" ref={ref}>
      <div className="shift-tracking-container">
        <motion.div
          className="shift-tracking-img-box"
          variants={leftVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          <img src="/images/RealtimeTracking.png" alt="Real-Time Shift Tracking" className="shift-tracking-img" />
        </motion.div>
        <motion.div
          className="shift-tracking-content"
          variants={rightVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          <h2 className="shift-tracking-title">Real-Time Shift Tracking</h2>
          <p className="shift-tracking-desc">
            Live shift views with role-based filters let managers and teams stay in sync, manage changes instantly, and avoid coverage gaps — especially in 24/7 care environments.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProductShiftTracking; 